<div *ngIf="spinner.isBusy" id="spinner_fullscreen">
    <div id="fullscreen_container">
        <app-spinner [type]="type"></app-spinner>
    </div>
</div>